import {
	IFilterDefinition,
	ISelectFilterDefinition,
	ITextFilterDefinition
} from '@evinced-private/ui-common';

import {
	DEFAULT_ENVIRONMENT_DISPLAY_NAME,
	DEFAULT_UNIT_ID_DISPLAY_NAME,
	ENVIRONMENT_LABEL_KEY,
	UNIT_ID_LABEL_KEY
} from 'src/common/consts/platformConfigConsts';
import { IPinnableSelectFilterDefinition } from 'src/common/helpers/FiltersPanelHelper';

import { DASHBOARD_DATE_RANGE_OPTIONS } from '../../constants/DashboardFiltersDefinitions';
import { createSingleSelectFilter } from '../../helpers/FilterCreationHelpers';

const searchFilter: ITextFilterDefinition = {
	id: 'searchValue',
	label: 'Search',
	filterType: 'text',
	defaultValue: '',
	componentProps: {}
};

const severityFilter: ISelectFilterDefinition = {
	id: 'severities',
	label: 'Severity',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Select',
		allSelectedPlaceholder: 'All Severities',
		someItemsSelectedText: (numberOfItems: number) => `Severities (${numberOfItems})`,
		isMultiple: true,
		id: 'severities',
		label: 'Severity',
		listboxWidth: '150px'
	}
};

const issueTypeFilter: ISelectFilterDefinition = {
	id: 'types',
	label: 'Issue Type',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Select',
		allSelectedPlaceholder: 'All Issue Types',
		someItemsSelectedText: (numberOfItems: number) => `Issue Types (${numberOfItems})`,
		isMultiple: true,
		id: 'types',
		label: 'Issue Type',
		listboxWidth: '150px'
	}
};

const dateRangeFilter: IPinnableSelectFilterDefinition = {
	id: 'dateRange',
	label: 'Date range',
	filterType: 'select',
	defaultValue: [DASHBOARD_DATE_RANGE_OPTIONS[0]],
	isPinned: true,
	componentProps: {
		placeholder: 'Last 30 days',
		isMultiple: false,
		id: 'dateRange',
		label: 'Date range',
		listboxWidth: '180px'
	}
};

export const getIssuesPageFilterDefinitions = (
	unitIdDisplayName: string = DEFAULT_UNIT_ID_DISPLAY_NAME,
	environmentDisplayName: string = DEFAULT_ENVIRONMENT_DISPLAY_NAME
): IFilterDefinition[] => {
	const unitIdFilter = createSingleSelectFilter(UNIT_ID_LABEL_KEY, unitIdDisplayName, {
		allSelectedPlaceholder: `All ${unitIdDisplayName}s`
	});

	const environmentFilter = createSingleSelectFilter(
		ENVIRONMENT_LABEL_KEY,
		environmentDisplayName,
		{
			allSelectedPlaceholder: `All ${environmentDisplayName}s`
		}
	);

	return [
		searchFilter,
		unitIdFilter,
		environmentFilter,
		severityFilter,
		issueTypeFilter,
		dateRangeFilter
	];
};
